export const constants = {
    UNAUTHORIZED: 1,
    ACCESS_DENIED: 2,
    BAD_CREDENTIALS: 3,
    USER_NOT_LOGGED: 4,
    VALIDATION_ERROR: 5,
    NO_CHAT_THREAD_ASSOCIATED: 6
}